import React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

type Props = {
  onClick: () => void
};

class CampaignAssetsUpload extends React.PureComponent<Props> {
  render() {
    return (
      <section className="campaign-assets-upload" onClick={this.props.onClick}>
        <div className="campaign-assets-upload__container">
          <SVGDynamicIcon
            name="plus-inside-circle-custom-bg"
            width={25}
            height={25}
            customColor="grey-light"
          />
        </div>
      </section>
    );
  }
}

export default CampaignAssetsUpload;
